/**
 * Normalizes a given date to UTC with time set to 00:00:00.000.
 *
 * @param date - The date to normalize. Can be a `Date` object or `null`.
 * @returns A new `Date` object normalized to UTC, or `null` if the input is `null`.
 */
export const normalizeDate = (date: Date | null): Date | null => {
  if (!date) return null;
  return new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0),
  );
};
